module.exports = __webpack_public_path__ + "static/JL.190207.COH.WEBW.Gallery1-08f24c39a41654572810d8707ee941b9.jpg";